import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import {
  buildRawSearchString,
  type FlatCompareFormValues,
  serializeFormParams,
} from "../ComparativeAnalysisForm.utils";

/**
 * @returns a function that updates compare-runs search params (compact `env`/`pipeline`/… format)
 * without re-encoding `:` in PITs. Preserves non-form params (e.g. `tab`).
 */
export const useUpdateSearchParams = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  return useCallback(
    (
      params: Partial<Record<keyof FlatCompareFormValues, string | null | undefined>>
    ) => {
      const compact = serializeFormParams({
        env1: params.env1 ?? undefined,
        env2: params.env2 ?? undefined,
        pipeline1: params.pipeline1 ?? undefined,
        pipeline2: params.pipeline2 ?? undefined,
        pit1: params.pit1 ?? undefined,
        pit2: params.pit2 ?? undefined,
        task1: params.task1 ?? undefined,
        task2: params.task2 ?? undefined,
      });
      const qs = buildRawSearchString(compact, searchParams);
      void navigate(
        {
          pathname,
          search: qs.length > 0 ? `?${qs}` : "",
        },
        { replace: true }
      );
    },
    [navigate, pathname, searchParams]
  );
};
